<template>
  <ul class="tab-list">
      <li v-for="tab in tabs" v-bind:key="uuidv4(tab)" @click="handleTab(tab.locationId)" class="themepark highlight" v-bind:class="{active: tab.active}">
          <span>{{tab.locationName}}</span>
          <span class="rectangle"></span>
      </li>
      
  </ul>
</template>

<script>
import Vue from "vue";

export default {
  props: ["tablistdata"],
  data() {
    return {
      tabs: this.tablistdata
    };
  },
  mounted() {
    this.tabs.forEach(tab => {
        if(tab.active) {
          this.$emit("activetab", tab);
        }
      });
  },
  methods: {
    uuidv4() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(
        c
      ) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },

    handleTab(tabId) {
      this.tabs.forEach(tab => {
        if (tab.locationId === tabId) {
          tab.active = true;
          this.$emit("activetab", tab);
        } else {
          tab.active = false;
        }
      });
    }
  }
};
</script>
